<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-va-optimization-unclassified-single-msg-existing-intent">
    <div class="existing-intent-popover-title">
      <img @click="controller.handlePageModalClose()" class="back-arrow" src="../../assets/icons/icon_assign_to_existing_back.svg" alt="">
      <span>Assign unclassified message to existing intent</span> 
    </div>
      
    <div style="
    height: calc(100% - 122px);
    min-height: 381px;" v-if="controller.intentList && controller.selectedMessage">
      <div class="existing-intent-popover-header">Unclassified message</div>
      <!-- <el-tooltip :content="selectedMessage.message" popper-class="unclassified-msg-popper" effect="dark" placement="bottom"> -->
        <div class="existing-intent-popover-item">
          <div class="message-content" @mouseover="controller.mouseover($event, controller.selectedMessage.message, 'dropdown')" @mouseout="controller.mouseout">
            {{controller.selectedMessage.message}}
          </div>
        </div>
      <!-- </el-tooltip> -->
      <div v-if="controller.enableSuggestedIntents">
        <div class="existing-intent-popover-header">
          Suggested intent
        </div>
        <div class="existing-intent-popover-item">
          <div @mouseover="controller.mouseover($event, controller.selectedMessage.suggestedIntent, 'dropdown')" @mouseout="controller.mouseout">
            {{controller.selectedMessage.suggestedIntent}}
          </div>
        </div>
        <div class="existing-intent-popover-header">
          Classifier probability
        </div>
        <div class="existing-intent-popover-item">
          <!-- <div @mouseover="controller.mouseover($event, `Total: ${selectedMessage.total}`, 'dropdown')" @mouseout="controller.mouseout"> -->
            <div>{{Math.round(controller.selectedMessage.classifierProbability * 100)}}%</div>
          <!-- </div> -->
        </div>
      </div>
    
      <div class="existing-intent-popover-header">
        Assigned intent
      </div>
      <div class="existing-intent-popover-item" @mouseover="controller.mouseover($event, controller.selectedMessage.assignedIntent, 'dropdown')" @mouseout="controller.mouseout">
        <el-select
          v-model="controller.selectedMessage.assignedIntent"
          @visible-change="visibleChange"
          collapse-tags
          size="mini"
          style="margin-left: 5px;"
          popper-class="assign-unclassified-msg-to-single-intent-dropdown"
          placement="bottom">

          <div class="div-search-input">
            <div class="search-button material-icons">search</div>
              <el-input
                ref="searchIntents"
                class="search-inp"
                placeholder="Search intents"
                v-model="searchIntentKeyword"
                >
              </el-input><i v-if="searchIntentKeyword!=''" class="fas fa-times-circle" @click="clearSearchInput"></i>
          </div>

          <el-option-group v-if="controller.enableSuggestedIntents" label="Suggested intent">
            <div @mouseover="controller.mouseover($event, controller.selectedMessage.suggestedIntent, 'fixed')" @mouseout="controller.mouseout">
              <el-option :label="controller.selectedMessage.suggestedIntent" :value="controller.selectedMessage.suggestedIntent"></el-option>
            </div>
          </el-option-group>

          <el-option-group label="Select intent">
            <!-- <div v-for="(intent) in controller.intentList.filter(el => el!=controller.selectedMessage.suggestedIntent)" :key="intent" @mouseover="controller.mouseover($event, intent, 'fixed')"> -->
            <div v-if="filteredIntents.length>0">
              <div v-for="(intent) in filteredIntents.filter(el => el!=controller.selectedMessage.suggestedIntent)" :key="intent" @mouseover="controller.mouseover($event, intent, 'fixed')" @mouseout="controller.mouseout">
                <el-option
                  placement="bottom"
                  :key="intent"
                  :label="intent"
                  :value="intent">
                </el-option>
              </div>
            </div>
            <div v-else class="no-search-result">
              No items match your search.
            </div>
          </el-option-group>
        </el-select>
      </div>
    </div>
  
    <div class="intent-action-popup-bottom-flex">
      <div class="intent-action-dropdown-cancel-btn" @click="controller.handlePageModalClose()">Cancel</div>
      <button ref="exitingIntentSaveBtn" class="intent-action-dropdown-save-btn" @click="this.controller.handleExitingIntentSave" :disabled="!enableSaveButton">Save</button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'wy-va-optimization-unclassified-single-msg-existing-intent',
  props: ["controller"],

  data() {
    return {
      searchIntentKeyword: ''
    }
  },

  computed: {
    enableSaveButton() {
      return this.controller.selectedMessage && this.controller.selectedMessage.assignedIntent;
    },
    filteredIntents() {
      return this.controller.intentList ? this.controller.intentList.filter(item=>{ return item.toLowerCase().includes(this.searchIntentKeyword.trim().toLowerCase()) }) : [];
    }
  },

  methods: {
  clearSearchInput(){
    this.searchIntentKeyword = '';
  },
  visibleChange(open) {
    if(!open) {
      this.$refs.exitingIntentSaveBtn.focus()
    }
  },
  async handleExitingIntentSave() {
    if(this.controller.selectedMessage && this.controller) {
      this.controller.selectedMessage.status = 'E';
      let res = await this.controller.saveOptimizationUnclassifiedMessages([this.controller.selectedMessage]);
      if(res.status == 200) {
        this.controller.selectedMessage.originItem.status = this.controller.selectedMessage.status;
        this.controller.selectedMessage.originItem.assignedIntent = this.controller.selectedMessage.assignedIntent;
        this.controller.selectedMessage = null;
        this.controller.handlePageModalClose()
      }
    }
  },
  }
})

</script>


<style lang="scss">
  .assign-unclassified-msg-to-single-intent-dropdown {
    width: 80%;
    height: 449px;
    .el-select-dropdown__wrap {
      max-height: 459px;
      min-height: 455px;
    }
    .material-icons {
      background: transparent;
      position: relative;
      display: inline-block;
      left: 10px;
      top: 1px;
      z-index: 5;
    }
    i.fas.fa-times-circle {
      margin-right: 11px;
      left: -46px;
      position: relative;
    }
    .div-search-input {
      display: flex;
      // border: 1px solid #CAD2DA;
      border-radius: 4px;
      width: 575px;
      margin: 20px;
      font-size: 14.22px;
      align-items: center;
      color: #6D7175;

      .search-inp.el-input {
        left: -24px;
        position: relative;
      }
    }
    input.el-input__inner {
      // border: unset !important;
      border-width: 1px !important;
      border-radius: 5px;
      height: 30px;
      padding-left: 40px;
      padding-right: 28px;
      width: 575px;
    }
    .el-select-group__wrap li{
      // padding: 5px 0px 5px 20px;
      .el-select-group div {
        margin: 5px 0px 5px 0px;
        .tooltips {
          display: none;
        }
        .el-select-dropdown__item {
          padding: 5px 0px 5px 20px;
          line-height: 26px;
          .tooltips {
            display: block;
          }
        }
      }
    }
    .el-select-group__wrap .el-select-group__title {
      padding: 5px 0px 5px 20px;
    }
    .el-select-group__wrap:not(:last-of-type)::after {
      height: unset;
      background: unset;
    }
    .el-select-dropdown__item.selected {
      color: #106FBC;
      font-weight: 400;
      background-color: #E8F1FF;
    }
    .el-select-group__wrap:not(:last-of-type) {
      padding-bottom: unset !important;
    }
    .no-search-result {
      padding: 0px 0px 0px 20px;
      font-size: 12px;
    }
    .el-input__inner:hover {
      background-color: #F4F6F8;
    }
    .el-input__inner:focus {
      border-color: #106FBC !important;
      background-color: #FFF !important;
    }
  }
  .wy-va-optimization-unclassified-single-msg-existing-intent {
    padding: 0px !important;
    height: calc(100% - 41px);
    min-height: 505px;
    width: 97% !important;
    margin: 21px;
    border: 1px solid #CAD2DA;
    border-radius: 5px;   

    img.back-arrow {
      margin-right: 19px;
      cursor: pointer;
    }
    .el-input__icon {
      height: unset;
    }

    .el-select .el-input__inner:focus {
      border-color: #828E9A !important;
    }
    .assign-unclassified-msg-to-intent-dropdown {
      width: 80%;
    }
    .el-select {
      margin-left: 0px !important;

      .el-input__inner{
        font-size: 14.22px !important;
      }
    }
    .el-select .el-input .el-select__caret {
      color: #828E9A !important;
      font-size: 14px !important;
    }
    .el-select-dropdown__item.hover, .el-select-dropdown__item:focus{
      // color: #106FBC !important;
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: 16px;
      font-weight: 400;
    }

    .el-select:hover, .el-select:focus {
      .el-input__inner {
        border-color: #106FBC !important;
      }
      .el-select__caret {
        color: #106FBC !important;
      }    
    }
    .existing-intent-popover-item .el-input__inner:focus {
      // border-color: #106FBC !important;
      border-color: #C0C4CC !important;
    }
    .existing-intent-popover-item .el-input__inner:hover {
      border-color: #106FBC !important;
    }

    .existing-intent-popover-header {
      color: #828E9A !important;
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: 14.22px;
      padding: 20px 15px 10px 15px !important;
    }

    .intent-action-dropdown-cancel-btn{
      color: var(--site-button-cancel-btn-primary-color);
      border: 1px solid var(--site-button-cancel-btn-primary-border-color);
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: 15px;
      font-weight: 400;
      padding: 8px 16px 8px 16px;
      display: flex;
      border-radius: 5px;
      height: fit-content;
      width: fit-content;
      cursor: pointer;
      background: transparent;
      margin-right: 15px;
      align-items: center;
      justify-content: center;
      &:hover{
        background: #F4F6F8;
      }
    }

    .intent-action-dropdown-save-btn {
      width: fit-content;
      height: fit-content;
      padding: 8px 16px 8px 16px;
      font-size: 15px;
      cursor: pointer;
      background: var(--site-button-primary-btn-background-primary-color);
      color: var(--site-button-primary-btn-text-primary-color) !important;
      border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      border-radius: 5px;
      margin-right: 15px;
      align-items: center;
      justify-content: center;
    }
    .intent-action-dropdown-save-btn:hover {
      border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
      background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
      border-radius: 5px;
      color: var(--site-button-primary-btn-text-primary-color) !important;
    }
    .intent-action-dropdown-save-btn:active {
      background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
    }
    .intent-action-dropdown-save-btn:focus {
      border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
      border-radius: 5px;
      color: var(--site-button-primary-btn-text-primary-color) !important;
    }
    .intent-action-dropdown-save-btn:disabled{
      background: var(--site-button-primary-btn-disabled-background-primary-color) !important;
      cursor: not-allowed;
    }

    .intent-action-popup-bottom-flex {
      display: flex;
      justify-content: flex-end;
      padding-top: 13px;
      border-top: 1px solid #CAD2DA;
      width: 100%;
      padding-bottom: 11px !important;
    }

    .existing-intent-popover-item {
      width: 100%;
      font-size: 14.22px;
      position: inherit;
      > div {
        color: var(--site-font-tertiary-color);
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: 14.22px;
        padding: 10px 15px !important;
        cursor: pointer;
        width: fit-content;
        max-width: 309px;
        text-align: left;
        top: 5px;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .el-select.el-select--mini {
        position: inherit;
        width: 100%;
        max-width: 570px;
        .el-input.el-input--mini.el-input--suffix {
          position: inherit;
          
        }
        .el-input.el-input--mini.el-input--suffix.is-focus {
          .el-input__inner {
            border-color: #106FBC !important;
          }
          .el-select__caret.el-input__icon {
            color: #106FBC !important;
          }
        }
        .el-input__inner {
          padding-left: 0px;
          width: 100%;
          // max-width: 309px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          border-radius: 0px;
          background-color: transparent;
          border-color: #C0C4CC;
        }
        .el-input__suffix {
          position: relative;
          right: 25px;
        }
      }
    }
    .existing-intent-popover-title {
      color: var(--site-font-tertiary-color) !important;
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      display: flex;
      border-bottom: 1px solid #CAD2DA;
      justify-content: flex-start;
      padding: 18px !important;
      font-weight: 500;
      font-size: 18px;
      display: flex;
      align-items: center;
      a.pop-close-icon {
        font-size: 35px;
        color: #5C5F62;
        cursor: pointer;
        position: relative;
        bottom: 3px;
        font-weight: 200;
        float: right; 
      }

    }
    div.tooltips {
      display:block;
      position:absolute;
      padding: 5px 10px;
      max-width: 300px;
      width: max-content;
      border-radius: unset;
      white-space: pre-wrap;
      word-wrap: break-word;
      border: 1px solid #6e7044;
      background-color: #D1D5D8;
      color: var(--site-font-tertiary-color);
      z-index: 999;
      line-height: 18px;
    }
    div.tooltips {
      font-size: 12px !important;
      font-weight: 500 !important;
      padding: 5px 10px !important;
      animation: fadeIn .5s;
      -webkit-animation: fadeIn .5s;
      -moz-animation: fadeIn .5s;
      -o-animation: fadeIn .5s;
      -ms-animation: fadeIn .5s;
    }
    div.tooltips.fadeOut {
      animation: fadeOut .5s;
      -webkit-animation: fadeOut .5s;
      -moz-animation: fadeOut .5s;
      -o-animation: fadeOut .5s;
      -ms-animation: fadeOut .5s;
    }
    @keyframes fadeIn {
      0% { opacity: 0; }
      100% { opacity: 1; }
    }
    @keyframes fadeOut {
      0% { opacity: 1; }
      100% { opacity: 0; }
    }
  }

  </style>